import { Message } from 'element-ui';
import Cookies from 'js-cookie'
function add0(m) { return m < 10 ? '0' + m : m }
//时间format转换
function formatTimer(timer, type) {
    // if(!time) return "暂无数据"
    if (!timer) return "--"
    let time = new Date(timer);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    if (type == 'day') {
        return y + '-' + add0(m) + '-' + add0(d);
    } else {
        let h = time.getHours();
        let mm = time.getMinutes();
        let s = time.getSeconds();
        return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
    }
};
function formatDateTime(dateString) {
    const date = new Date(dateString);

    // 获取年月日时分秒（注意月份从0开始，需要+1）
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 补0成两位
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // 拼接成 "YYYY-MM-DD HH:MM:SS" 格式
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
// 性别：0->未知；1->男；2->女
const genderOpt = [{ label: '未知', value: '0' }, { label: '男', value: '1' }, { label: '女', value: '2' },];
// 风险商户 是否有风险 0-否，1-是
const riskFlagOpt = [{ label: '无风险', value: '0' }, { label: '有风险', value: '1' }];
// 是否逾期 0-否1-是
const overFlagOpt = [{ label: '未逾期', value: '0' }, { label: '逾期', value: '1' }];
// 是否挂账 0-否 1-是
const pendingStatusOpt = [{ label: '未挂账', value: '0' }, { label: '已挂账', value: '1' }];
// 纠纷订单状态： 0-否，1-是
const issueStatusOpt = [{ label: '否', value: '0' }, { label: '是', value: '1' }];
// 贴息类型 0-用户贴息 1-商户贴息
const feeTypeOpt = [{ label: '用户贴息', value: '0' }, { label: '商户贴息', value: '1' }];
// 付款意愿 0-无，1-有
const isPayOpt = [{ label: '否', value: '0' }, { label: '是', value: '1' }];
// 是否失联 0-否，1-是
const isLostOpt = [{ label: '否', value: '0' }, { label: '是', value: '1' }];
// 商户模式 0-否，1-是
const modelOpt = [{ label: '线下', value: '0' }, { label: '线上', value: '1' }]
// 是否停催 0-停催，1-正在催收 // =》更改 collect_status  催收状态 0-未催收，1-正在催收 2-停催
const collectStatusOpt = [{ label: '未催收', value: '0' }, { label: '正在催收', value: '1' }, { label: '停催', value: '2' }]
// 付款状态 0-未付款 1-已部分付款 2-已还清，3-已逾期 4-已作废
const returnStatusOpt = [{ label: '未付款', value: '0' }, { label: '已部分付款', value: '1' }, { label: '已还清，3', value: '2' },
{ label: '已逾期', value: '3' }, { label: '已作废', value: '4' }];
//订单状态  更新版  100-待关联用户，0-用户资料填写中,1-机审中，2-人工审核中，3-审核未通过 4-资料重传 5-审批通过 6-款项支付中 7-订单已完成，付款中 8-已退货 9-已提前结清 10-已结清 11-订单取消 12-已展期 13-订单作废 14-合同签署中
//订单状态 100-待关联用户，0-用户资料填写中,1-机审中，2-人工审核中，3-审核未通过 4-资料重传 5-审批通过 6-款项支付中 7-订单已完成，付款中 8-已退货 9-已提前结清 10-已结清 11-订单取消 12-已展期
const statusOpt = [{ label: '待关联用户', value: '100' }, { label: '用户资料填写中', value: '0' }, { label: '机审中', value: '1' },
{ label: '人工审核中', value: '2' }, { label: '审核未通过', value: '3' },
//  {label:'资料重传',value:'4'},
{ label: '审批通过', value: '5' }, { label: '款项支付中', value: '6' }, { label: '付款中', value: '7' },
//  {label:'已退货',value:'8'},
{ label: '已提前结清', value: '9' }, { label: '已结清', value: '10' },
{ label: '订单取消 ', value: '11' },
//  {label:'已展期',value:'12'},
{ label: '订单作废', value: '13' }, { label: '合同签署中', value: '14' }];
//财务管理-线下付款入账   筛选条件   订单状态  只保留“款项支付中”和“订单已完成，付款中”
const statusCwOpt = [{ label: '款项支付中', value: '6' }, { label: '付款中', value: '7' },]
//支付状态    0-待支付 1-支付成功 2-支付失败 3-已取消
const payStatusOpt = [{ label: '待支付', value: '0' }, { label: '支付成功', value: '1' }, { label: '支付失败', value: '2' }, { label: '已取消', value: '3' },]

// 提现审批状态  1-待审批 2-审批通过待放款 3-已付款 4-审批拒绝 5-已取消
const statusTXSPOpt = [{ label: '待审批', value: '1' }, { label: '审批通过待放款', value: '2' }, { label: '已付款', value: '3' },
{ label: '审批拒绝', value: '4' }, { label: '已取消', value: '5' },];
// 银盛提现审批状态  1-待审批 2-审批通过待放款 3-已付款 4-审批拒绝 5-已取消
const statusYsTXSPOpt = [{ label: '审批通过', value: '2' }, { label: '审批拒绝', value: '4' }];
// 订单取消的审批     审批状态 2-审批通过 3-审批拒绝 4-已取消
//  const statusQXSPOpt =[{label:'审批通过',value:'2'},{label:'审批拒绝',value:'3'},{label:'已取消',value:'4'},];
const statusQXSPOpt = [{ label: '审批通过', value: '2' }, { label: '审批拒绝', value: '3' },];
// 是否停止进件 0-否，1-是
const applyFlagOpt = [{ label: '否', value: '0' }, { label: '是', value: '1' }]
//是否关闭提现 0-否，1-是
const withdrawFlagOpt = [{ label: '否', value: '0' }, { label: '是', value: '1' }]
//特殊状态  风控管理状态
//  const statusFKOpt = [
//     {label:'审批通过',value:'1'},
//     {label:'暂停',value:'2'},
//     {label:'已删除',value:'3'},
//   ];
//  风控管理  审批状态
const statusSPOpt = [
    { label: '待审批', value: '0' },
    { label: '正常', value: '1' },
    { label: '暂停', value: '2' },
    { label: '已删除', value: '3' },
    { label: '审批拒绝', value: '4' },
];

// 平台类型
const platformTypeOpt = [
    { label: '银盛支付', value: '1' },
    { label: '连连支付', value: '2' },
    { label: '其他', value: '0' },
];
//  商户列表   商户状态
const statusMerOpt = [
    { label: '待审批', value: '0' },
    { label: '正常', value: '1' },
    { label: '暂停', value: '2' },
    { label: '审批拒绝', value: '4' },
];


//  催收管理=》付款提醒状态 
const statusCollReturnOpt = [
    { label: '成功', value: '1' },
    { label: '失败', value: '2' },
];
//  催收管理=》付款提醒=>信息类型
const typeCollReturnOpt = [
    { label: '手机短信', value: '1' },
    { label: '微信到期付款提醒', value: '2' },
    { label: '微信逾期付款通知', value: '3' },
    { label: '其他', value: '10' },
];

//  财务管理   订单取消审批  订单状态筛选筛选
const statusOrderSXOpt = [
    { label: '待运营审批', value: '1' },
    { label: '审批通过', value: '2' },
    { label: '审批拒绝', value: '3' },
    { label: '已拒绝', value: '4' },
    { label: '待财务审批', value: '5' },
];
//  订单管理   运营  订单取消审批  订单状态筛选筛选
const statusOrderYISXOpt = [
    { label: '待运营审批', value: '1' },
    { label: '审批通过', value: '2' },
    { label: '审批拒绝', value: '3' },
    { label: '已取消', value: '4' },
    { label: '待财务审批', value: '5' },
];
//  财务管理  提现审批  状态
const statusOrderTXSXOpt = [
    { label: '待审批', value: '1' },
    { label: '审批通过', value: '2' },
    { label: '已付款', value: '3' },
    { label: '审批拒绝', value: '4' },
    { label: '已取消', value: '5' },
    { label: '提现失败', value: '6' },
];
//  产品管理  产品状态
const statusCPOpt = [
    { label: '正常', value: '1' },
    { label: '暂停', value: '2' },
    { label: '已删除', value: '3' },
];
//  风控管理  复核操作   审批状态
const statusRiskSPOpt = [
    { label: '审批通过', value: '1' },
    { label: '审批拒绝', value: '4' },
];

//  催收员账号状态管理 帐号启用状态：0->禁用；1->启用
const statusCSOpt = [
    { label: '禁用', value: '0' },
    { label: '启用', value: '1' },
    { label: '已删除', value: '2' },
];
//  催收结果 1-沟通有效 2-沟通无效 3-未接通
const statusCSResultOpt = [
    { label: '沟通有效', value: '1' },
    { label: '沟通无效', value: '2' },
    { label: '未接通', value: '3' },
];
//    资源类型 1-管理端 2-商户端 3-业务员端
const typeOpt = [
    { label: '管理端', value: '1' },
    { label: '商户端', value: '2' },
    { label: '业务员端', value: '3' },
    { label: '资金方端', value: '4' },
];
//  商户操作员时，是否为商户主账户 0-否 1-是
const isDefaultOpt = [
    { label: '否', value: '0' },
    { label: '是', value: '1' },
];
// 会计科目信息 状态 1-正常 2-暂停 3-已删除  statusKJOpt
const statusKJOpt = [
    { label: '正常', value: '1' },
    { label: '暂停', value: '2' },
    { label: '已删除', value: '3' },
];
// 平台管理员时，是否为催收员 0-否 1-是
const isCollectOpt = [
    { label: '否', value: '0' },
    { label: '是', value: '1' },
];
// 产品管理  是否纯账单 0-否 1-是
const isPureOpt = [
    { label: '否', value: '0' },
    { label: '是', value: '1' },
];
// 订单列表  是否有优先金额 is_amtplatform  1：是  0：否
const isAmtplatformOpt = [
    { label: '是', value: '1' },
    { label: '否', value: '0' },
];
// 订单列表  是否纯账单 amt_first=0表示纯账单
const amtFirstOpt = [
    { label: '否', value: '1' },
    { label: '是', value: '0' },
];
// 是否有滞纳金
const overInterestOpt = [
    { label: '否', value: '0' },
    { label: '是', value: '1' },
];
// 付款管理 商户是否分账  
const amtMerchantOpt = [
    { label: '是', value: '1' },
    { label: '否', value: '0' },
];
// ，是否绑卡 0-否 1-是
const bindingStatusOpt = [
    { label: '否', value: '0' },
    { label: '是', value: '1' },
];
// ，是否融资成功
const financingStatusOpt = [
    { label: '否', value: '0' },
    { label: '是', value: '1' },
];
// 付款方式 支付通道 weixin-微信,alipay-支付宝,union-平台代扣,offline-下线转账
//   把支付记录查询 和 付款管理界面中的支付通道，"weixin", "alipay" 改成 yinshenweixin、yinshenalipayjs  去掉“其他”

const channelOpt = [
    // {label:'微信',value:'weixin'},
    { label: '银盛微信', value: 'yinshenweixin' },
    // {label:'支付宝',value:'alipay'},
    { label: '银盛支付宝', value: 'yinshenalipayjs' },
    { label: '银盛代扣', value: 'union' },

    { label: '连连微信', value: 'lianlianweixin' },
    { label: '连连支付宝', value: 'lianlianalipayjs' },
    { label: '连连代扣', value: 'lianlianunion' },

    { label: '线下转账', value: 'offline' },
    { label: '微信', value: 'weixin' },
    { label: '汇付微信', value: 'huifuweixin' },
    { label: '汇付支付宝', value: 'huifualipay' },
    // {label:'其他',value:''},
];
//针对付款查询,收款管理  lianlianalipay
const channel_tzOpt = [
    // {label:'微信',value:'weixin'},
    { label: '银盛微信', value: 'yinshenweixin' },
    // {label:'支付宝',value:'alipay'},
    { label: '银盛支付宝', value: 'yinshenalipayjs' },
    { label: '银盛代扣', value: 'union' },

    { label: '连连微信', value: 'lianlianweixin' },
    { label: '连连支付宝', value: 'lianlianalipay' },
    { label: '连连代扣', value: 'lianlianunion' },

    { label: '线下转账', value: 'offline' },
    { label: '微信', value: 'weixin' },
     { label: '汇付微信', value: 'huifuweixin' },
    { label: '汇付支付宝', value: 'huifualipay' },
    // {label:'其他',value:''},
];
// 文件上传，附件格式fileType：1-图片，2-录音 3-短信
const fileTypeOpt = [
    { label: '图片', value: '1' },
    { label: '录音', value: '2' },
    { label: '短信', value: '3' },
];
// type:附件类型1-订单佐证2-订单审批，3-订单放款
const typeNameOpt = [
    { label: '订单佐证', value: '1' },
    { label: '订单审批', value: '2' },
    { label: '订单放款', value: '3' },
    { label: '其他', value: '4' },
];
// approveStatus 审批状态 0-待审批 1-审批通过，2-审批拒绝，3-已取消
const approveStatusOpt = [
    { label: '待审批', value: '0' },
    { label: '审批通过', value: '1' },
    { label: '审批拒绝', value: '2' },
    { label: '已取消', value: '3' },
];
// reviewStatus 回访状态 1-回访正常、2-回访异常、3-未回访
const reviewStatusOpt = [
    { label: '回访正常', value: '1' },
    { label: '回访异常', value: '2' },
    { label: '未回访', value: '3' },
];
// 回购订单状态  是否已回购订单 0-否，1-是
const proxyFlagOpt = [
    { label: '否', value: '0' },
    { label: '是', value: '1' },
];
// "担保人类型 1-个人 2-公司
const typeDBROpt = [
    { label: '个人', value: '1' },
    { label: '公司', value: '2' },
];

// "律师函类型 1-欠费催收函，2-恶意投诉
const typeLawyerLetterOpt = [
    { label: '欠费催收函', value: '1' },
    { label: '恶意投诉', value: '2' },
];
// 逾期天数选择
const overDaySelectOpt = [
    { label: '0-4天', value: '1' },
    { label: '5-9天', value: '2' },
    { label: '10-14天', value: '3' },
    { label: '15-19天', value: '4' },
    { label: '20-29天', value: '5' },
    { label: '30天以上', value: '6' },
];
const returnTypeArr = ["gender", "riskFlag", "overFlag", "issueStatus", "feeType", "isPay", "model", "isLost",
    "returnStatus", "applyFlag", "withdrawFlag", "collectStatus", "status", "type", "isDefault", "statusCS", "statusCSResult",
    "statusKJ", "isCollect", "channel", "bindingStatus", "financingStatus", "statusTXSP", "statusYsTXSP", "fileType", "pendingStatus", "statusRiskSP",
    "statusCP", "statusOrderSX", "statusOrderTXSX", "statusCw", "payStatus", 'approveStatus', "reviewStatus", "typeDBR", "isPure", "amtFirst",
    'amtMerchant', "overInterest", "platformType",];
export default {
    //返回options
    getOption(str) {
        return eval(str + 'Opt')
    },

    formatTimer(timer, type) {
        // if(!time) return "暂无数据"
        let time;
        if (!timer) {
            time = new Date();
        } else {
            time = new Date(timer);
        }
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        let h = time.getHours();
        let mm = time.getMinutes();
        let s = time.getSeconds();
        if (type == 'day') {
            return y + '-' + add0(m) + '-' + add0(d);
        } else if (type == 'year') {
            return y;
        } else if (type == 'month') {
            return m;
        } else if (type == 'date') {
            return d;
        } else if (type == 'y-m-d') {
            return y + '-' + add0(m) + '-' + add0(d);
        } else if (type == 'h') {
            return h;
        } else if (type == 'week') {
            let weekDate = y + '-' + add0(m) + '-' + add0(d);
            return time.getDay(weekDate);
        } else {
            return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
        }
    },
    //文件上传  action

    // 附件上传，附件格式fileType：1-图片，2-录音 3-短信
    // type:附件类型1-订单佐证2-订单审批，3-订单放款     0  用户头像
    uploadAction(fileParams) {
        let Obj = {};
        let actionUrl = ""
        if (process.env.NODE_ENV == "production") {
            actionUrl = "https://gatetest.efenda.cn"
        } else {
            actionUrl = "https://gatetest.efenda.cn"
            // actionUrl = "https://gatetest.efenda.cn"
        }
        if (!fileParams) {
            //获取Authorization
            const token = Cookies.get('loginToken')
            Obj.headers = { Authorization: token };
            Obj.action = `${actionUrl}/mall-admin/minio/upload?type=1&fileType=1`
            return Obj;
        } else if (fileParams.type == 'importListenClass') {
            //获取Authorization
            const token = Cookies.get('loginToken')
            Obj.headers = { Authorization: token };
            Obj.action = `${actionUrl}/mall-admin/member/importStudyLog/${fileParams.id}`
            return Obj;
        } else if (fileParams == 'importSmsSend') {
            const token = Cookies.get('loginToken')
            Obj.headers = { Authorization: token };
            Obj.action = `${actionUrl}/mall-admin/collect/importSmsSend`
            return Obj;
        }
        if (fileParams == 'noLogin') {
            //不登录上传接口
            actionUrl = "https://gatetest.efenda.cn"
            Obj.action = `${actionUrl}/mall-portal/userOss/uploadNoLogin`
            return Obj;
        }

        let fileType = fileParams.fileType || '1';//默认为图片
        let type = fileParams.type || '0';//默认用户头像
        let orderId = fileParams.orderId;
        let name = fileParams.name || "";

        if (orderId) {
            if (name) {
                Obj.action = `${actionUrl}/mall-admin/minio/upload?type=${type}&orderId=${orderId}&name=${name}`
            } else {
                Obj.action = `${actionUrl}/mall-admin/minio/upload?type=${type}&fileType=${fileType}&orderId=${orderId}`
            }
        } else {
            //针对用户头像
            Obj.action = `${actionUrl}/mall-admin/minio/upload?type=${type}&fileType=${fileType}`
        }
        return Obj;
    },
    //根据filed返回相应的状态值 label.type = 1,执行options逻辑   type == 2  执行转换时间戳
    // dataObj:数据源    label:当前label数据
    // label.type  number类型   isSub   是否截取     subNum 截取数量
    rValByFiled(dataObj, label, isSub, subNum) {
        // if(Object.keys(dataObj).length == 0) return "暂无数据";
        if (Object.keys(dataObj).length == 0) return "--";
        let value = dataObj[label.filed]
        if (Object.prototype.toString.call(value) == '[object Number]') {
            value = value.toString();
        }
        let valLabel = "";
        switch (label.type) {
            case 1:
                //执行options逻辑
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'Opt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 2:
                //执行转换时间格式  年月日  时分秒
                return formatTimer(value);
                break;
            case 22:
                //具体到天
                return formatTimer(value, 'day')
                break;
            case 3:
                // //单独处理   逾期状态    付款状态 0-未付款 1-已部分付款 2-已还清，3-已逾期 4-已作废  returnStatus
                // 除了已逾期  其他都是未逾期
                if (value == '3') {
                    valLabel = "已逾期";
                } else {
                    valLabel = "未逾期";
                }
                return valLabel;
                break;
            case 4:
                //执行options逻辑  特殊处理   相同字段 statusCSOpt  账号处理状态
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'CSOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 5:
                //执行options逻辑  特殊处理   会计科目信息 状态 1-正常 2-暂停 3-已删除  statusKJOpt
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'KJOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 6:
                //执行options逻辑  特殊处理  附件类型1-订单佐证2-订单审批，3-订单放款 4-其他    typeNameOpt
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'NameOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 7:
                //执行options逻辑  特殊处理  statusSPOpt
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'SPOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 8:
                //执行options逻辑  特殊处理  statusCPOpt   产品状态
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'CPOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 9:
                //执行options逻辑  特殊处理  statusOrderSXOpt   财务管理=》订单取消审批=》申请状态筛选
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'OrderSXOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 99:
                //执行options逻辑  特殊处理  statusOrderYISXOpt   订单管理=》订单取消审批=》申请状态筛选
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'OrderYISXOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel; statusOrderYISXOpt
                break;
            case 11:
                //执行options逻辑  特殊处理  statusOrderTXSXOpt   财务管理=》提现审批=》申请状态筛选
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'OrderTXSXOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 12:
                //执行options逻辑  特殊处理  statusCwOpt    //财务管理-线下付款入账   筛选条件   订单状态  只保留“款项支付中”和“订单已完成，付款中”
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'CwOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 13:
                //执行options逻辑  特殊处理  statusTXSPOpt    //商户自服务   提现管理  状态
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'TXSPOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 14:
                //执行options逻辑  特殊处理  statusYsTXSPOpt    //银盛   提现管理  状态
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'YsTXSPOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 15:
                //执行options逻辑  特殊处理  typeDBROpt    //担保人  状态
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'DBROpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 16:
                //执行options逻辑  特殊处理  statusMerOpt statusCollReturnOpt
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'MerOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 17:
                //执行options逻辑  特殊处理  statusCollReturnOpt 
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'CollReturnOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 18:
                //执行options逻辑  特殊处理  typeCollReturnOpt 
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'CollReturnOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 19:
                //执行options逻辑  特殊处理  channel_tzOpt 
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + '_tzOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;

            case 20:
                //执行options逻辑  特殊处理  typeLawyerLetterOpt 
                for (let item of returnTypeArr) {
                    if (item == label.filed) {
                        let arrStr = eval(label.filed + 'LawyerLetterOpt')
                        for (let itm of arrStr) {
                            if (value == itm.value) {
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
                break;
            case 10:
                //用于拼接字段   type:10,filedArr:['xrate','yrate'],format:'/'
                let filedArr = label.filedArr || [];
                for (let item of filedArr) {
                    let filedVal = dataObj[item] || "-";
                    valLabel += `${filedVal}${label.format}`
                }
                valLabel = valLabel.replace(/.$/, "");//替换最后一个字符串
                return valLabel;
                break;
            default:
                if (!value) {
                    // return "暂无数据";
                    return "--";
                } else {
                    let subNumer = subNum || 7;
                    if (isSub && value.length > subNumer) {
                        value = value.substr(0, subNumer) + '...'
                    }
                }
                // return dataObj[label.filed]

                return value;
        }

    },
    // 给labelList 中的字段赋值数据源  filed,
    //label  字段名字   labelList 字段列表   dataObj数据源
    echoFiled(label, filed, labelList, dataObj) {
        if (labelList.length == 0 || !label || !dataObj || !filed) return ""
        for (let item of labelList) {
            if (label == item.label) {
                item[filed] = dataObj;
                break;
            }
        }
    },
    // 给labelList 中的字段赋值数据源  filed,
    //label  字段名字   labelList 字段列表   value值
    echoFiledVal(label, filed, labelList, val) {
        if (labelList.length == 0 || !label || !filed) return ""
        for (let item of labelList) {
            if (label == item.label) {
                item[filed] = val;
                break;
            }
        }
    },
    // 给labelList 中的字段赋值数据源  filed,
    //label  字段名字   labelList 字段列表   dataObj数据源
    echoValue(label, labelList, dataObj) {
        if (labelList.length == 0 || !label) return ""
        for (let item of labelList) {
            if (label == item.label) {
                item.value = dataObj;
                break;
            }
        }
    },
    // 根据字段得到labelList 中的值
    getFiledVal(label, labelList) {
        if (labelList.length == 0 || !label) return "";
        let val = "";
        for (let item of labelList) {
            if (label == item.label) {
                val = item.value;
                break;
            }
        }
        return val;
    },
    /**
     * //获取对象数组value值
     * @param {*} objArr 
     * @param {*} data 
     * @returns obj
     */
    getDataObj: (objArr) => {
        let valObj = {}
        if (objArr.length == 0 || !objArr) return valObj;
        for (let item of objArr) {
            //时间  需要拆分  多个字段 startTimer  endtimer
            if (item.typeValue == 'daterange' && item.filedArr) {
                for (let [index, im] of item.filedArr.entries()) {
                    valObj[im] = item.value ? item.value[index] : "";
                }
            } else if (item.typeValue == 'monthrange' && item.filedArr) {
                for (let [index, im] of item.filedArr.entries()) {
                    valObj[im] = item.value ? item.value[index] : "";
                }
            } else if (item.filed == 'statusList' && item.value == "") {
                valObj[item.filed] = undefined;
            } else {
                valObj[item.filed] = item.value;
            }
        }
        return valObj;
    },
    /**
     * 重置数据对象
     */
    resetObj: (objArr) => {
        if (objArr.length == 0 || !objArr) return "";
        for (let item of objArr) {
            item.value = item.resetValue || "";
        }
    },
    // number类型转String类型
    numTostring(val) {
        if (Object.prototype.toString.call(val) == '[object Number]') {
            val = val.toString();
        }
        return val;
    },
    //更改lableList  中的typeValue类型值  typeValue
    /**labelStr:label名
     * labelList 数据源
     * valStr 更改的value值
     */
    updateLableFiled(labelStr, labelList, valStr) {
        if (!labelStr || labelList.length == 0 || !valStr) return "";
        for (let item of labelList) {
            if (labelStr == item.label) {
                item.typeValue = valStr
                break;
            }
        }
    },
    //得到rules   监听回显  ,并得到值
    getWatchRule(arr, ruleForm) {
        let obj = {};
        if (!ruleForm) return obj;
        if (Object.keys(ruleForm).length == 0) return obj;
        if (arr.length == 0 || !arr) return obj
        for (let item of arr) {
            let val = ruleForm[item.filed] || "";
            if (Object.prototype.toString.call(val) == '[object Number]') {
                val = val.toString();
            }
            if (val) {
                obj[item.filed] = val;
            } else {
                obj[item.filed] = item.value;
            }
        }
        return obj;
    },
    //得到rules,并得到值
    getRule(arr) {
        let obj = {};
        if (arr.length == 0 || !arr) return obj
        for (let item of arr) {
            if (item.filed) {
                obj[item.filed] = item.value;
            }
        }
        return obj;
    },
    // 数组对象赋值？
    /**
     * 
     * @param {*} labelArr  数组数据结构对象
     * @param {*} dataObj   dataObj 数据源对象
     */
    echoArrData(labelArr, dataObj) {
        if (labelArr.length == 0 || !labelArr) return [];
        if (!dataObj) return [];
        for (let item of labelArr) {
            if (item.type == "join") {
                let valLabel = '';
                //用于拼接字段   type:10,filedArr:['xrate','yrate'],format:'/'
                let filedArr = item.filedArr || [];
                for (let itm of filedArr) {
                    let filedVal;
                    if (!dataObj[itm] && dataObj[itm] !== 0) {
                        filedVal = "-"
                    } else {
                        filedVal = dataObj[itm]
                    }
                    valLabel += `${filedVal}${item.format}`
                }
                valLabel = valLabel.replace(/.$/, "");//替换最后一个字符串
                item.value = valLabel
            } else {
                item.value = dataObj[item.filed];
            }
        }
        return labelArr;
    },
    //回显对象数据
    objEcho: (obj, data) => {
        if (Object.prototype.toString.call(obj) === '[object Object]' &&
            Object.keys(obj) != 0) {
            for (let key in obj) {
                let val = data[key];
                if (Object.prototype.toString.call(val) == '[object Number]') {
                    val = val.toString();
                }
                if (val) {
                    obj[key] = val
                }
            }
        }
        return obj;
    },
    //赋值select数据
    assSelectData() { },
    //暂无数据
    noData(value) {
        if (Object.prototype.toString.call(value) == '[object Number]') {
            value = value.toString();
        }
        // if(!value) return '暂无数据'
        if (!value) return '--'
        return value;
    },
    //时间format转换
    format: (time) => {
        if (!time) return "--"
        var time = new Date(time);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
    },
    formatTime: (time) => {
        var time = new Date(time);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        return y + '-' + add0(m) + '-' + add0(d);
    },
    //二进制文件对象转换img base64
    readImg(file) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const reader = new FileReader();
            reader.onload = function (e) {
                // img.src = e.target.result;
                resolve(e.target.result)
            }
            reader.onerror = function (e) {
                reject(e)
            }
            reader.readAsDataURL(file);
            // img.onload = function(){
            //     resolve(img)
            // }
            // img.onerror = function(e){
            //     reject(e)
            // }
        })
    },
    msg(title, type = 'success', duration = 1500) {
        Message({
            message: title,
            type: type,
            duration: duration,
        })
    },

    // 防抖
    debounce(fn, wait) {
        if (fn.id) {
            clearTimeout(fn.id)
        }
        return (function (...args) {
            let that = this;
            fn.id = setTimeout(() => {
                fn.apply(that, args)
            }, wait);
        })()
    },

    // 节流
    throttle(fn, wait) {
        let timer = null
        return function (...args) {
            if (!timer) {
                timer = setTimeout(() => {
                    fn.apply(this, args)
                }, wait);
            }
        }
    },
    hidePhone(cellValue) {
        if (cellValue == null || cellValue === '') {
            return 'N/A';
        }
        return cellValue.substring(0, 3) + '****' + cellValue.substring(7);
    }
}


// WEBPACK FOOTER //
// ./src/utils/utils.js